<template>
  <div class="text-black px-5 h-page">
    <div class="flex justify-end text-2xl">
      <i @click="close" class="el-icon-close cursor-pointer"></i>
    </div>

    <div class="text-center mb-3">
      <div class="text-2xl font-bold">
        Kết quả khám {{ formatHRDate(hr && hr.created_at) }}
      </div>
      <div class="text-xl font-bold">{{ getCSYT() }}</div>
    </div>

    <div class="mb-4">
      <div class="mb-1 text-xl fw-600" v-if="user">
        <span class="mr-1">{{ user.name }}</span>
        <span>{{ getInfo() }}</span>
      </div>
      <div class="text-base fw-500" v-if="hr">
        <div class="mb-1">
          Mã SKB:
          <span class="ml-2">{{ hr.code }}</span>
        </div>
      </div>
    </div>

    <div v-if="conclusion" class="mb-4">
      <div class="row text-lg mb-3">
        <div class="col-md-2">Lý do khám bệnh</div>
        <div class="col-md-10">{{ conclusion.reason }}</div>
      </div>
      <div class="row text-lg mb-3">
        <div class="col-md-2">Diến biến</div>
        <div class="col-md-10">{{ conclusion.progression }}</div>
      </div>
      <div class="row text-lg mb-3">
        <div class="col-md-2">Chẩn đoán</div>
        <div class="col-md-10">{{ conclusion.diagnose }}</div>
      </div>
      <div class="row text-lg mb-3">
        <div class="col-md-2">Kết luận</div>
        <div class="col-md-10">{{ conclusion.prehistoric }}</div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-6">
        <div class="fs-17 fw-700">Kết quả Xét nghiệm</div>
        <div
          class="my-2 cursor-pointer"
          v-for="item in indications"
          :key="item.id"
        >
          <span class="underline text-base" @click="goToIndication(item.id)">{{
            item.name
          }}</span>
        </div>
      </div>
      <div class="col-md-6" v-if="medicines">
        <div class="fs-17 fw-700">Đơn thuốc</div>
        <div class="my-2" v-for="item in medicines" :key="item.id">
          <span class="underline text-base">{{ item.name }}</span>
        </div>
      </div>
    </div>

    <div>
      <div class="fs-17 fw-700">File và link kèm theo</div>
    </div>

    <div class="row mt-3" v-for="(file, index) in files" :key="index + 'file'">
      <div class="col-md-4 flex items-center mb-3">
        <div class="mr-4">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_24814_125783)">
              <path
                d="M6.14703 0H14.1772L20.9748 7.09195V20.8779C20.9748 22.6023 19.5771 24 17.8526 24H6.14703C4.42256 24 3.0249 22.6023 3.0249 20.8779V3.12212C3.0249 1.39769 4.42256 0 6.14703 0V0Z"
                fill="#0263D1"
              />
              <path
                opacity="0.302"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.1675 0V7.0337H20.9747L14.1675 0Z"
                fill="white"
              />
              <path
                d="M6.95996 16.6667V12.7879H9.60769V13.5492H7.89746V14.3447H9.43913V15.1079H7.89746V16.6667H6.95996Z"
                fill="white"
              />
              <path
                d="M11.0173 12.7879V16.6667H10.0798V12.7879H11.0173Z"
                fill="white"
              />
              <path
                d="M11.6058 16.6667V12.7879H12.5433V15.9053H14.1569V16.6667H11.6058Z"
                fill="white"
              />
              <path
                d="M14.6423 16.6667V12.7879H17.3468V13.5492H15.5798V14.3447H17.2085V15.1079H15.5798V15.9053H17.3468V16.6667H14.6423Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_24814_125783">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="grid grid-cols-2">
          <div
            class="col-span-2 text-blue-900 cursor-pointer hover:underline"
            @click="downloadFile(file.file_name, file.name)"
          >
            {{ file.name }}
            <svg
              class="ml-2 mb-1"
              width="15"
              height="17"
              viewBox="0 0 15 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.22748 9.14986C4.15458 9.22423 4.09672 9.31271 4.05723 9.4102C4.01775 9.50768 3.99742 9.61225 3.99742 9.71786C3.99742 9.82347 4.01775 9.92803 4.05723 10.0255C4.09672 10.123 4.15458 10.2115 4.22748 10.2859L6.56081 12.6859C6.63312 12.7608 6.71914 12.8204 6.81392 12.861C6.9087 12.9016 7.01036 12.9225 7.11304 12.9225C7.21571 12.9225 7.31737 12.9016 7.41215 12.861C7.50693 12.8204 7.59295 12.7608 7.66526 12.6859L9.99859 10.2859C10.1451 10.1352 10.2273 9.9309 10.2273 9.71786C10.2273 9.50482 10.1451 9.3005 9.99859 9.14986C9.85213 8.99922 9.65349 8.91459 9.44637 8.91459C9.23925 8.91459 9.04061 8.99922 8.89415 9.14986L7.89081 10.1899V0.917859C7.89081 0.705686 7.80887 0.502203 7.66301 0.352173C7.51715 0.202144 7.31932 0.117859 7.11304 0.117859C6.90676 0.117859 6.70893 0.202144 6.56307 0.352173C6.4172 0.502203 6.33526 0.705686 6.33526 0.917859V10.1899L5.33193 9.14986C5.25962 9.07488 5.1736 9.01536 5.07882 8.97475C4.98404 8.93413 4.88238 8.91322 4.7797 8.91322C4.67703 8.91322 4.57537 8.93413 4.48059 8.97475C4.38581 9.01536 4.29979 9.07488 4.22748 9.14986ZM11.7797 5.71786H10.2241C10.0179 5.71786 9.82004 5.80214 9.67418 5.95217C9.52831 6.1022 9.44637 6.30569 9.44637 6.51786C9.44637 6.73003 9.52831 6.93352 9.67418 7.08354C9.82004 7.23357 10.0179 7.31786 10.2241 7.31786H11.7797C11.986 7.31786 12.1838 7.40214 12.3297 7.55217C12.4755 7.7022 12.5575 7.90569 12.5575 8.11786V13.7179C12.5575 13.93 12.4755 14.1335 12.3297 14.2835C12.1838 14.4336 11.986 14.5179 11.7797 14.5179H2.44637C2.24009 14.5179 2.04226 14.4336 1.8964 14.2835C1.75054 14.1335 1.66859 13.93 1.66859 13.7179V8.11786C1.66859 7.90569 1.75054 7.7022 1.8964 7.55217C2.04226 7.40214 2.24009 7.31786 2.44637 7.31786H4.00193C4.20821 7.31786 4.40604 7.23357 4.5519 7.08354C4.69776 6.93352 4.7797 6.73003 4.7797 6.51786C4.7797 6.30569 4.69776 6.1022 4.5519 5.95217C4.40604 5.80214 4.20821 5.71786 4.00193 5.71786H2.44637C1.82753 5.71786 1.23404 5.97072 0.796455 6.4208C0.35887 6.87089 0.113037 7.48134 0.113037 8.11786V13.7179C0.113037 14.3544 0.35887 14.9648 0.796455 15.4149C1.23404 15.865 1.82753 16.1179 2.44637 16.1179H11.7797C12.3985 16.1179 12.992 15.865 13.4296 15.4149C13.8672 14.9648 14.113 14.3544 14.113 13.7179V8.11786C14.113 7.48134 13.8672 6.87089 13.4296 6.4208C12.992 5.97072 12.3985 5.71786 11.7797 5.71786Z"
                fill="#667085"
              />
            </svg>
          </div>
          <div class="mr-2">{{ formatDMY(file.created_at) }}</div>
          <div>{{ file.created_by && file.created_by.name }}</div>
        </div>
      </div>
    </div>

    <div class="row" v-for="(link, index) in links" :key="'link' + index">
      <div class="col-md-4 flex items-center mb-3">
        <div class="mr-4">
          <svg
            class="mx-1"
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.25193 11.2154L4.07193 12.3621C3.76251 12.6715 3.34284 12.8453 2.90526 12.8453C2.46767 12.8453 2.04801 12.6715 1.73859 12.3621C1.42917 12.0526 1.25534 11.633 1.25534 11.1954C1.25534 10.7578 1.42917 10.3381 1.73859 10.0287L4.76526 6.99539C5.06233 6.69735 5.46261 6.52491 5.88327 6.51374C6.30393 6.50257 6.71279 6.65353 7.02526 6.93539L7.10526 7.00205C7.23168 7.12582 7.40209 7.1943 7.579 7.19243C7.75591 7.19055 7.92482 7.11847 8.04859 6.99205C8.17236 6.86563 8.24084 6.69523 8.23896 6.51832C8.23709 6.34141 8.16501 6.17249 8.03859 6.04872C8.00097 6.00007 7.96092 5.95335 7.91859 5.90872C7.34949 5.4136 6.61348 5.15329 5.85964 5.18052C5.10579 5.20775 4.39048 5.52049 3.85859 6.05539L0.791925 9.08872C0.27083 9.65592 -0.0109942 10.4025 0.0053085 11.1726C0.0216112 11.9426 0.33478 12.6766 0.879414 13.2212C1.42405 13.7659 2.15803 14.079 2.92809 14.0953C3.69815 14.1116 4.44473 13.8298 5.01193 13.3087L6.16526 12.1821C6.27914 12.0578 6.34174 11.8951 6.34047 11.7265C6.33919 11.558 6.27414 11.3962 6.1584 11.2737C6.04266 11.1512 5.88482 11.0771 5.71664 11.0663C5.54846 11.0555 5.38242 11.1087 5.25193 11.2154ZM12.3786 1.72205C11.8178 1.16473 11.0592 0.851913 10.2686 0.851913C9.47794 0.851913 8.71941 1.16473 8.15859 1.72205L7.00526 2.84872C6.89138 2.97295 6.82878 3.13571 6.83005 3.30423C6.83133 3.47276 6.89638 3.63455 7.01212 3.75705C7.12786 3.87954 7.2857 3.95366 7.45388 3.96449C7.62206 3.97531 7.7881 3.92204 7.91859 3.81539L9.07193 2.66872C9.38134 2.3593 9.80101 2.18547 10.2386 2.18547C10.6762 2.18547 11.0958 2.3593 11.4053 2.66872C11.7147 2.97814 11.8885 3.3978 11.8885 3.83539C11.8885 4.27297 11.7147 4.69264 11.4053 5.00205L8.37859 8.03539C8.08152 8.33343 7.68124 8.50587 7.26058 8.51704C6.83992 8.52821 6.43106 8.37724 6.11859 8.09539L6.03859 8.02872C5.91217 7.90495 5.74176 7.83648 5.56486 7.83835C5.38795 7.84023 5.21903 7.9123 5.09526 8.03872C4.97149 8.16514 4.90301 8.33555 4.90489 8.51246C4.90676 8.68937 4.97884 8.85829 5.10526 8.98205C5.15368 9.03158 5.20488 9.07832 5.25859 9.12206C5.82838 9.61569 6.56408 9.87502 7.31746 9.84781C8.07084 9.82059 8.78591 9.50885 9.31859 8.97539L12.3519 5.94205C12.9128 5.38477 13.2304 4.62821 13.2354 3.83755C13.2404 3.0469 12.9324 2.28638 12.3786 1.72205Z"
              fill="#6E7883"
            />
          </svg>
        </div>
        <div class="grid grid-cols-2">
          <div
            class="col-span-2 text-blue-900 cursor-pointer hover:underline"
            @click="openLink(link)"
          >
            {{ link.name }}
          </div>
          <div class="mr-2">{{ formatDMY(link.created_at) }}</div>
          <div>{{ link.created_by && link.created_by.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
import downloadS3 from '../../utils/downloadS3'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'ConsultationDetail',
  data () {
    return {
      loading: false,
      user: null,
      hr: null,
      conclusion: null,
      links: [],
      files: []
    }
  },
  computed: {
    indications () {
      const array = []
      if (this.conclusion) {
        for (const item of this.conclusion?.indication_orders) {
          array.push(...item.indications)
        }
      }
      return array
    },
    medicines () {
      const array = []
      if (this.conclusion) {
        for (const item of this.conclusion?.prescriptions) {
          array.push(...item.person_medicines)
        }
      }
      return array
    }
  },
  mounted () {
    this.getConsultationById()
    this.user = this.$user
  },
  methods: {
    goToIndication (id) {
      this.$router.push({ path: `/health-records/indication/${id}` })
    },
    formatHRDate (date) {
      return date && moment(date).format('DD-MM-YYYY')
    },
    getGender () {
      return appUtils.getGender(this.$user?.gender)
    },
    async getConsultationById () {
      this.loading = true
      await this.$rf.getRequest('AuthRequest').getConsultationById(this.$route.params.id)
        .then(res => {
          this.hr = res.data.health_record
          this.conclusion = res.data
          this.files = _.filter(res.data.consultation_files, ['type', 1])
          this.links = _.filter(res.data.consultation_files, ['type', 2])
        })
        .catch(error => {
          console.log(error)
        }).finally(() => {
          this.loading = false
        })
    },
    getInfo () {
      let result = '('
      if (this.user.person?.gender) result = `${result}${appUtils.getGender(this.user.person?.gender)}`
      if (this.user.person?.age) result = `${result} - ${this.user.person.age}`
      if (this.user.person?.address) result = `${result} - ${this.user.person.address}`
      return result + ')'
    },
    formatDMY (date) {
      return date && moment(date).format('HH:mm DD-MM-YYYY')
    },
    formatDate (date) {
      return date && moment(date).format('DD-MM-YYYY')
    },
    getImageURL (avatar) {
      return appUtils.getImageURL(avatar)
    },
    openLink (link) {
      if (!link.url) return
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
      if (isSafari) {
        if (confirm('Bạn đang được chuyển hương đến ' + link.url + '. Xác nhận chuyển hướng')) {
          window.location.href = link.url
        }
      } else window.open(link.url)
    },
    async downloadFile (fileName) {
      if (!fileName) return
      downloadS3.downloadFileRC(fileName)
    },
    close () {
      this.$router.go(-1)
    },
    getCSYT () {
      if (this.hr?.clinic?.organization?.name) {
        return this.hr?.clinic?.organization?.name
      } else {
        return this.hr?.clinic?.name
      }
    }
  }
}
</script>

            <style scoped lang="scss">
.h-page {
  min-height: calc(100vh - 150px);
}
</style>
